import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

// TODO: Typa
const ControlledCheckBox = (props) => {
  const { control } = useFormContext();
  // const { isDirty, errors } = useFormState();

  const { disabled, label, value, name, required, clickOnlyOnBox = false, ...rest } = props;

  // let isError = false;
  // let errorMessage = '';
  // if (errors && Object.prototype.hasOwnProperty.call(errors, name)) {
  //   isError = true;
  //   errorMessage = errors[name].message;
  // }
  const [internalValue, setInternalValue] = React.useState(value || ''); // String

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field }) => (
        <FormControlLabel
          sx={{
            alignItems: 'flex-start',
            ...(clickOnlyOnBox && { pointerEvents: 'none' }),
            '& .MuiCheckbox-root': {
              pt: 0,
              ...(clickOnlyOnBox && { pointerEvents: 'auto' }),
            },
            '&.Mui-disabled': {
              color: (thm) => `${thm.palette.text.disabled} !important`,
              cursor: 'not-allowed',
            },
          }}
          disableTypography
          control={
            <Checkbox
              onChange={(e) => {
                let valueCopy = internalValue;
                // update checkbox value
                valueCopy = e.target.checked ? '1' : '0';
                // send data to react hook form
                field.onChange(valueCopy);
                setInternalValue(valueCopy);
              }}
              checked={internalValue === '1'}
              value={value}
              disabled={disabled}
            />
          }
          label={<span>{label}</span>}
        />
      )}
    />
  );
};

export default ControlledCheckBox;
